import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// begin styled components
const sharedThumbStyles = css`
  background: var(--cc_color_link_secondary);
  height: 14px;
  width: 14px;
  border-radius: 100%;
  transition: all 0.2s;
`;
const sharedThumbFocusStyles = css`
  outline: var(--cc_size_border_width_m) solid var(--cc_color_link_primary);
  outline-offset: var(--cc_size_spacing_xxs);
`;
const sharedThumbHoverStyles = css`
  box-shadow: 0 0 0 var(--cc_size_spacing_s)
    var(--cc_color_link_primary_alpha_20);
`;
const Container = styled.div`
  position: relative;
`;
const InputLayout = styled.div`
  position: relative;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: calc(50% - (var(--cc_size_spacing_xs) / 2));
    height: var(--cc_size_spacing_xs);
    background: var(--cc_color_border_input_inactive);
    border-radius: var(--cc_size_border_radius_pill);
  }
`;
const Input = styled.input`
  all: initial;
  position: relative;
  box-sizing: border-box;
  display: block;
  width: 100%;
  margin: 0;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;

  &::-webkit-slider-thumb {
    ${sharedThumbStyles}
    -webkit-appearance: none;
    appearance: none;
  }
  &::-moz-range-thumb {
    ${sharedThumbStyles}
    border: none;
  }
  &:focus-visible {
    outline: none;
    &::-webkit-slider-thumb {
      ${sharedThumbFocusStyles}
    }
    &::-moz-range-thumb {
      ${sharedThumbFocusStyles}
    }
  }
  &:hover {
    &::-webkit-slider-thumb {
      ${sharedThumbHoverStyles}
    }
    &::-moz-range-thumb {
      ${sharedThumbHoverStyles}
    }
  }
`;
const Label = styled.label`
  all: initial;
`;
// end styled components

/**
 * @deprecated Use { InputRange } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/inputrange--docs
 */

const RangeInput = ({
  disabled,
  id,
  label,
  min,
  max,
  onChange,
  onFocus,
  onBlur,
  step,
  value,
}) => {
  const handleChange = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onChange(e);
  };

  return (
    <Container>
      <Label htmlFor={id}>{label}</Label>
      <InputLayout>
        <Input
          type="range"
          id={id}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          onChange={handleChange}
          onFocus={onFocus}
          onBlur={onBlur}
          value={value}
        />
      </InputLayout>
    </Container>
  );
};

RangeInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};
RangeInput.defaultProps = {
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  disabled: false,
  min: 0,
  max: 100,
  step: undefined,
};
export default RangeInput;
